import constant from '@/common/resources/constant'
import _ from 'lodash'
import { UI_CODE } from '@/common/resources/const'
export default {
  getItem (key) {
    if (!key) {
      return null
    }
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
      encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) ||
      null
  },
  setItem (key, value, expire, domain, path, secure) {
    if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
      return false
    }
    let cookieData = ''
    cookieData += encodeURIComponent(key)
    cookieData += '='
    cookieData += encodeURIComponent(value)
    if (expire) {
      switch (expire.constructor) {
        case String:
          cookieData += '; expires='
          cookieData += expire
          break
        case Date:
          cookieData += '; expires='
          cookieData += expire.toUTCString()
          break
        default:
          break
      }
    }
    cookieData += domain ? '; domain=' + domain : ''
    cookieData += path ? '; path=' + path : ''
    cookieData += secure ? '; secure=' + secure : ''
    document.cookie = cookieData
    return true
  },
  setAutoLoginCredential (credential) {
    const expires = new Date()
    expires.setHours(0, 0, 0, 0)
    expires.setDate(expires.getDate() + 365)
    this.setItem('credential', JSON.stringify(credential), expires.toUTCString(), constant.URL_COOKIE_DOMAIN, '/')
  },
  removeItem (key, domain, path) {
    if (!key) {
      return false
    }
    document.cookie = encodeURIComponent(key) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
      (domain ? '; domain=' + domain : '') + (path ? '; path=' + path : '')
    return true
  },
  removeItems ({ keyList, domain = constant.URL_COOKIE_DOMAIN, path = '/' }) {
    keyList.forEach((key) => {
      this.removeItem(key, domain, path)
    })
  },
  hasItem (key) {
    if (!key) {
      return false
    }
    return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=')).test(document.cookie)
  },
  clear () {
    const nameList = document.cookie
      .replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '')
      .split(/\s*(?:=[^;]*)?;\s*/)
    nameList.forEach((name) => {
      if (/^_ga.*|^wcs.*|^usrID/gi.test(name) !== true) {
        this.removeItem(decodeURIComponent(name), constant.URL_COOKIE_DOMAIN)
        this.removeItem(decodeURIComponent(name), constant.URL_COOKIE_DOMAIN, '/')
      }
    })
  },
  changeUserInfo (name, image) {
    let userInfo = this.userInfo()
    userInfo.profilename = name
    userInfo.profileimage = image
    this.setItem('cs', JSON.stringify(userInfo), null, constant.URL_COOKIE_DOMAIN, '/')
  },
  userInfo (key) {
    const userInfo = JSON.parse(this.getItem('cs'))
    if (key) {
      return userInfo ? userInfo[key] : undefined
    }
    return userInfo
  },
  wasSetWavveOn () {
    return this.getItem('pz') !== null
  },
  isWavveOn () {
    const pz = JSON.parse(this.getItem('pz'))
    return _.get(pz, 'isPooqzone', false) === true
  },
  isCsInfo () {
    return this.getItem('cs') !== null
  },
  getPooqZoneTempInfo () {
    return JSON.parse(this.getItem('pzInfo'))
  },
  getPooqZoneInfo () {
    return JSON.parse(this.getItem('pz'))
  },
  getPooqZoneId () {
    const pz = JSON.parse(this.getItem('pz'))
    return pz ? pz['pooqzoneid'] : 'none'
  },
  getPooqZoneType () {
    const pz = JSON.parse(this.getItem('pz'))
    const pooqzoneType = pz ? pz['pooqzonetype'] : 'none'
    return pooqzoneType || 'none'
  },
  getSaveUserId () {
    const userId = this.getItem('userId')
    return userId || 'none'
  },
  getUno () {
    const csInfo = JSON.parse(this.getItem('cs'))
    return csInfo ? csInfo['uno'] : 'none'
  },
  getCredential () {
    let appCredential = this.getItem('app-credential')
    if (appCredential) {
      return decodeURIComponent(appCredential)
    }

    let csInfo = JSON.parse(this.getItem('cs'))
    return csInfo ? decodeURIComponent(csInfo['credential']) : 'none'
  },
  setMovieUiCodeToGN17 () {
    let csInfo = JSON.parse(this.getItem('cs'))
    if (csInfo !== null) {
      csInfo = _.set(csInfo, 'movieuicode', UI_CODE.MOVIE_17)
      this.setItem('cs', JSON.stringify(csInfo), null, constant.URL_COOKIE_DOMAIN, '/')
    }
  },
  isPpvConfirmUser () {
    const csInfo = JSON.parse(this.getItem('cs'))
    return _.get(csInfo, 'movieuicode', '') === UI_CODE.MOVIE_17
  },
  hasCredential () {
    return this.getCredential() !== 'none'
  },
  hasNotCredential () {
    return this.getCredential() === 'none'
  },
  isVerifiedAdultUser () {
    return String(this.getItem('verifiedAdult')) === '1'
  },
  isNotVerifiedAdultUser () {
    return !this.isVerifiedAdultUser()
  },
  getAutoLoginCredential () {
    return JSON.parse(this.getItem('credential'))
  },
  isTooltip (target) {
    const tooltip = this.getTooltip()
    if (tooltip !== 'none') {
      return tooltip[target] ? tooltip[target] : 'none'
    } else {
      return 'none'
    }
  },
  getTooltip () {
    const tooltip = JSON.parse(this.getItem('tooltip'))
    return tooltip || 'none'
  },
  setTooltip (target) {
    const expires = new Date()
    const tempTooltip = this.getTooltip()
    let tempObj = {}
    const tempData = {}
    expires.setHours(0, 0, 0, 0)
    expires.setDate(expires.getDate() + 365)
    if (tempTooltip === 'none') {
      tempData[target] = true
      tempObj = tempData
    } else {
      tempData[target] = true
      tempObj = _.assign(tempData, tempTooltip)
    }
    this.setItem('tooltip', JSON.stringify(tempObj), expires.toUTCString(), constant.URL_COOKIE_DOMAIN, '/')
  },
  getProfileId () {
    const csInfo = JSON.parse(this.getItem('cs'))
    return csInfo ? csInfo['profile'] : 'none'
  },
  getAdultSettings () {
    return this.getItem('adult-settings')
  },
  getLoginType () {
    const csInfo = JSON.parse(this.getItem('cs'))
    return csInfo ? csInfo['type'] : 'unknown'
  }
}
